/**
 * CONFIGURACIÓN DEL TENANT — el ÚNICO fichero que cambia un tenant para
 * restilizar el Pórtico «Despacho» (GEN-PX-001).
 *
 * Los valores por defecto son los de DKtec. Para un tenant nuevo: cambia solo
 * este fichero (y deja su logo en public/) y recompila. Todo el Pórtico nuevo
 * (libro de estilo y las pantallas Despacho) se ajusta, porque solo usa los
 * tokens --dk-* de src/styles/tokens-despacho.css, que este fichero sobrescribe
 * en arranque (src/tenant/aplicarTenant.js).
 *
 *  nombre   Nombre visible del tenant.
 *  logo     Ruta (bajo public/) o URL del logo. null = insignia con la inicial.
 *  idioma   Idioma por defecto (código ISO: 'es', 'en'…). De momento solo se
 *           declara y se muestra; aplicarlo a las pantallas es de otra HU.
 *  fuente   familia: nombre de la familia CSS. url: hoja de estilos que la
 *           carga (p. ej. Google Fonts) o null si ya está auto-alojada.
 *           OJO: una url externa hace una llamada a un tercero desde el
 *           navegador (R-PT-10 / US-66); preferir auto-alojar.
 *  colores  principal: acción, marca y positivo.
 *           profundo : raíl y cabecera (tinta oscura de marca).
 *           acento   : fin de degradados y halos de actividad.
 *           Los tonos derivados (tinta, tramo medio del degradado, tono claro,
 *           halo) NO se declaran: salen de estos tres. Hex de 6 dígitos.
 *
 * Fuera de este fichero (y de la interfaz) por ahora: editar esto desde el
 * Pórtico (otra HU).
 */
const tenant = {
  nombre: 'DKtec',
  logo: '/logos/dktec.svg',
  idioma: 'es',
  fuente: {
    familia: 'Inter',
    url: null,
  },
  colores: {
    principal: '#007A33',
    profundo: '#0B3D22',
    acento: '#1C9A4C',
  },
}

export default tenant
